<script>
    // Adapted from https://www.skeleton.dev/utilities/toasts
	import { crossfade } from 'svelte/transition';
	import { cubicInOut} from 'svelte/easing';
	import { flip } from 'svelte/animate';

	// Stores
	import { toastStore } from '../stores/Toast';

	// Props
    // Toast position
	export let position = 't';
	/** Maximum toasts that can show at once. */
	export let max = 3;
	/** The duration of the fly in/out animation. */
	export let duration = 250;

	/** The button label text. */
	export let buttonDismissLabel = '✕';

	// Local
	let cPosition
	let cAlign // items-center
	let animAxis = { x: 0, y: 0 };

	// Set Position
	switch (position) {
		// Middles
		case('t'): cPosition = 'justify-center items-start'; cAlign = 'items-center'; animAxis = { x: 0, y: -100 }; break;
		case('b'): cPosition = 'justify-center items-end'; cAlign = 'items-center'; animAxis = { x: 0, y: 100 }; break;
		case('l'): cPosition = 'justify-start items-center'; cAlign = 'items-start'; animAxis = { x: -100, y: 0 }; break;
		case('r'): cPosition = 'justify-end items-center'; cAlign = 'items-end'; animAxis = { x: 100, y: 0 }; break;
		// Corners
		case ('tl'): cPosition = 'justify-start items-start'; cAlign = 'items-start'; animAxis = { x: -100, y: 0 }; break;
		case ('tr'): cPosition = 'justify-end items-start'; cAlign = 'items-end'; animAxis = { x: 100, y: 0 }; break;
		case ('bl'): cPosition = 'justify-start items-end'; cAlign = 'items-start'; animAxis = { x: -100, y: 0 }; break;
		case ('br'): cPosition = 'justify-end items-end'; cAlign = 'items-end'; animAxis = { x: 100, y: 0 }; break;
	}

	function onAction(index) {
		$toastStore[index]?.action?.response();
		toastStore.close($toastStore[index].id);
	}

	// Filtered Toast Store
	$: filteredToasts = Array.from($toastStore).slice(0, max);

	// Crossfade animation for Toasts
	const [send, receive] = crossfade({
		duration: d => Math.sqrt(d * duration),

		fallback(node) {
			const style = getComputedStyle(node);
			const transform = style.transform === 'none' ? '' : style.transform;

			return {
				duration,
				easing: cubicInOut,
				css: (t, u) => `
					transform: ${transform} scale(${t}) translate(${u * animAxis.x}%, ${u * animAxis.y}%);
					opacity: ${t}
				`
			};
		}
	});
</script>

{#if $toastStore.length}
	<!-- Wrapper -->
	<div class="snackbar-wrapper">
		<!-- List -->
		<div class="snackbar" >
			{#each filteredToasts as t, i (t)}
				<div animate:flip={{ duration }} in:receive="{{key: t.id}}" out:send="{{key: t.id}}">
					<!-- Toast -->
					<div class="toast" role="alert" aria-live="polite">
						<div class="text-base">{@html t.message}</div>
						<div class="toast-actions">
							<button on:click={() => toastStore.close(t.id)}>{buttonDismissLabel}</button>
						</div>
					</div>
				</div>
			{/each}
		</div>
	</div>
{/if}

<style>

button {
    all:unset;
    margin-left: 1rem;
    cursor: pointer;
    color: whitesmoke;
    font-size: 1.5rem;
    font-weight: bold;
}
.snackbar-wrapper {
    display: flex; 
    position: fixed; 
    top: 0; 
    right: 0; 
    bottom: 0; 
    left: 0; 
    pointer-events: none; 
    justify-content: center; 
    align-items: flex-start; 
    z-index: 999;
    margin-top: 4rem;
}

.snackbar {
    display: flex; 
    flex-direction: column; 
    margin-top: 0.5rem; 
}

.toast {
    display: flex; 
    justify-content: space-between; 
    align-items: center; 
    text-align: center;
    pointer-events: auto; 
    background-color: #bf1212;
    color: whitesmoke;
    margin-left: 1rem;
    padding: 1rem;
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05); 
    border-radius: 1rem;
    margin-top: 1rem;
}

.toast-actions {
    display: flex; 
    margin-left: 0.5rem; 
    align-items: center; 
}



</style>